import React from 'react'
import Remarkable from 'remarkable'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Image from 'gatsby-image'
import Layout from '../components/Layout'
import BlogRoll from '../components/BlogRoll'

//import MoreIcon from '../img/question-down.svg'

var md = new Remarkable();

export const IndexPageTemplate = ({
  about,
  title,
  tagline,
  intro,
  headerImage,
  pitch,
  cta,
  footerImage
}) => (
  <div>
    <header>
      <div className="padded">
        <h1 className="tagline" dangerouslySetInnerHTML={{__html:md.render(tagline)}}></h1>
      </div>
      <Image className="background" fluid={headerImage.childImageSharp.fluid} />
      <div className="padded text-center-mobile"><p className="intro">{intro}</p></div>
      <div className="padded"><p className="support" dangerouslySetInnerHTML={{__html: title}}></p></div>
      <div className="mobile-relief">
        <a className="ynot-link button--reveal" href="#posts"><img src="/img/ynotsj.png" alt="Y (not) SJ?"/></a>
      </div>
    </header>
    <main>
      <h1 className="post-header">Why Not?</h1>
      <BlogRoll />
    </main>
    <footer>
      <div className="tablet--jail">
        <Image className="background" fluid={footerImage.childImageSharp.fluid} />
        <div className="pitch">
          <div className="padded"><p dangerouslySetInnerHTML={{__html: about}}></p></div>
          <div className="padded"><p dangerouslySetInnerHTML={{__html: pitch}}></p></div>
        </div>
      </div>
      <div className="padded"><h1 className="cta">{cta}</h1></div>
      <a className="button center" href="mailto:votefranksj@gmail.com">Questions? Why not ask.</a>
    </footer>
  </div>
)

IndexPageTemplate.propTypes = {
  headerImage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  footerImage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  tagline: PropTypes.string,
  intro: PropTypes.string,
  pitch: PropTypes.string,
  cta: PropTypes.string,
}

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <IndexPageTemplate
        title={frontmatter.title}
        tagline={frontmatter.header.tagline}
        intro={frontmatter.header.intro}
        headerImage={frontmatter.header.image}
        about={frontmatter.footer.about}
        pitch={frontmatter.footer.pitch}
        cta={frontmatter.footer.cta}
        footerImage={frontmatter.footer.image}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        header {
          tagline
          intro
          image {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
        footer {
          about
          pitch
          cta
          image {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          } 
        }
      }
    }
  }
`
